// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { PrescriberV3ClientGeneratedAddressUpsearchModel } from './prescriberV3ClientGeneratedAddressUpsearchModel.js';
import type { PrescriberV3ClientGeneratedEmailAddressUpsearchModel } from './prescriberV3ClientGeneratedEmailAddressUpsearchModel.js';
import type { PrescriberV3ClientGeneratedExternalIdUpsearchModel } from './prescriberV3ClientGeneratedExternalIdUpsearchModel.js';
import type { PrescriberV3ClientGeneratedPhoneUpsearchModel } from './prescriberV3ClientGeneratedPhoneUpsearchModel.js';
import type { PrescriberV3ClientGeneratedPrescriberLicenseUpsearchModel } from './prescriberV3ClientGeneratedPrescriberLicenseUpsearchModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class TCApiGatewayControllersAccountModelsPrescriberUpsearchModel {
    'prescriberId'?: number | null;
    'isActive'?: boolean;
    'firstName'?: string | null;
    'middleName'?: string | null;
    'lastName'?: string | null;
    'suffix'?: string | null;
    'nickname'?: string | null;
    'npi'?: string | null;
    'taxId'?: string | null;
    'note'?: string | null;
    'isNoteHighPriority'?: boolean;
    'prescriberLicenses'?: Array<PrescriberV3ClientGeneratedPrescriberLicenseUpsearchModel> | null;
    'externalIds'?: Array<PrescriberV3ClientGeneratedExternalIdUpsearchModel> | null;
    'addresses'?: Array<PrescriberV3ClientGeneratedAddressUpsearchModel> | null;
    'phoneNumbers'?: Array<PrescriberV3ClientGeneratedPhoneUpsearchModel> | null;
    'emailAddresses'?: Array<PrescriberV3ClientGeneratedEmailAddressUpsearchModel> | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof TCApiGatewayControllersAccountModelsPrescriberUpsearchModel>> = [
        {
            "name":     "prescriberId",
            "baseName": "prescriberId",
            "type":     "number"
        },
        {
            "name":     "isActive",
            "baseName": "isActive",
            "type":     "boolean"
        },
        {
            "name":     "firstName",
            "baseName": "firstName",
            "type":     "string"
        },
        {
            "name":     "middleName",
            "baseName": "middleName",
            "type":     "string"
        },
        {
            "name":     "lastName",
            "baseName": "lastName",
            "type":     "string"
        },
        {
            "name":     "suffix",
            "baseName": "suffix",
            "type":     "string"
        },
        {
            "name":     "nickname",
            "baseName": "nickname",
            "type":     "string"
        },
        {
            "name":     "npi",
            "baseName": "npi",
            "type":     "string"
        },
        {
            "name":     "taxId",
            "baseName": "taxId",
            "type":     "string"
        },
        {
            "name":     "note",
            "baseName": "note",
            "type":     "string"
        },
        {
            "name":     "isNoteHighPriority",
            "baseName": "isNoteHighPriority",
            "type":     "boolean"
        },
        {
            "name":     "prescriberLicenses",
            "baseName": "prescriberLicenses",
            "type":     "Array<PrescriberV3ClientGeneratedPrescriberLicenseUpsearchModel>"
        },
        {
            "name":     "externalIds",
            "baseName": "externalIds",
            "type":     "Array<PrescriberV3ClientGeneratedExternalIdUpsearchModel>"
        },
        {
            "name":     "addresses",
            "baseName": "addresses",
            "type":     "Array<PrescriberV3ClientGeneratedAddressUpsearchModel>"
        },
        {
            "name":     "phoneNumbers",
            "baseName": "phoneNumbers",
            "type":     "Array<PrescriberV3ClientGeneratedPhoneUpsearchModel>"
        },
        {
            "name":     "emailAddresses",
            "baseName": "emailAddresses",
            "type":     "Array<PrescriberV3ClientGeneratedEmailAddressUpsearchModel>"
        },
    ];

    static getAttributeTypeMap() {
        return TCApiGatewayControllersAccountModelsPrescriberUpsearchModel.attributeTypeMap;
    }
}
